export const highlightNumber = (
  str,
  numberFontSize = null,
  numberColor = null,
  numberFontWeight = null,
  characterFontSize = null,
  characterColor = null,
  characterFontWeight = null) => {
  if (numberFontSize === null) {
    numberFontSize = 16
  }
  if (numberColor === null) {
    numberColor = '#f2af17'
  }
  if (numberFontWeight === null) {
    numberFontWeight = 600
  }
  if (characterFontSize === null) {
    characterFontSize = 16
  }
  if (characterColor === null) {
    characterColor = '#000000'
  }
  if (characterFontWeight === null) {
    characterFontWeight = 300
  }

  let renderHtml = ''
  for (let i = 0; i < str.length; i++) {
    let ch = str.charAt(i)
    if ((ch >= '0' && ch <= '9') || ch === '.') {
      renderHtml += `<span style="font-size:${numberFontSize}px !important;color:${numberColor} !important;font-weight:${numberFontWeight} !important">${ch}</span>`
    } else {
      renderHtml += `<span style="font-size:${characterFontSize}px !important;color:${characterColor} !important;font-weight:${characterFontWeight} !important">${ch}</span>`
    }
  }
  return renderHtml
}
